<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const props = defineProps({
  secondsLeft: {
    type: Number,
    required: true,
  },
  waitingForResponse: {
    type: Boolean,
    default: false,
  },
});

const displayText = computed(() => {
  return t('CONVERSATION.AI_COOLDOWN.PROCESSING_MESSAGE', { seconds: props.secondsLeft });
});

const progressPercentage = computed(() => {
  return ((25 - props.secondsLeft) / 25) * 100;
});
</script>

<template>
  <div class="ai-suggestion-timer flex items-center gap-3 px-4 py-3 bg-blue-50 dark:bg-blue-900/20 border-b border-blue-200 dark:border-blue-800">
    <div class="flex-shrink-0">
      <fluent-icon
        icon="bot"
        size="20"
        class="text-blue-600 dark:text-blue-400"
      />
    </div>
    <div class="flex-grow">
      <div class="flex items-center justify-between mb-1">
        <span class="text-sm font-medium text-blue-900 dark:text-blue-100">
          {{ displayText }}
        </span>
        <span class="text-xs font-mono text-blue-700 dark:text-blue-300">
          {{ secondsLeft }}s
        </span>
      </div>
      <div class="w-full bg-blue-200 dark:bg-blue-800 rounded-full h-1.5">
        <div
          class="bg-blue-600 dark:bg-blue-400 h-1.5 rounded-full transition-all duration-300"
          :style="{ width: `${progressPercentage}%` }"
        />
      </div>
    </div>
  </div>
</template>

